/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Loaddocumentserror3Inputs */

const en_coinvestments_nrl_loaddocumentserror3 = /** @type {(inputs: Coinvestments_Nrl_Loaddocumentserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error loading documents. Please try again.`)
};

/**
* | output |
* | --- |
* | "Error loading documents. Please try again." |
*
* @param {Coinvestments_Nrl_Loaddocumentserror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_loaddocumentserror3 = /** @type {((inputs?: Coinvestments_Nrl_Loaddocumentserror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Loaddocumentserror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_loaddocumentserror3(inputs)
});
export { coinvestments_nrl_loaddocumentserror3 as "coInvestments_nrl_loadDocumentsError" }